import { useLocation, useNavigate } from "react-router-dom";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import { useContext, useEffect, useRef, useState } from "react";
import { BandoService } from "../../../services/BandoService";
import Select from "../../Form/Select";
import FiltriAvanzati from "../../Utility/FiltriAvanzati/FiltriAvanzati";
import { FormUtility } from "../../Utility/FormUtility";
import { RichiestaService } from "../../../services/RichiestaService";
import Modal from "../../Utility/Modal/Modal";
import ToastContext from "../../../../src/contexts/toast";
import moment from "moment";
import tuttiComuni from "../../Utility/json/tuttiComuni";
import { EmailService } from "../../../services/EmailService";
import { rolesCodes } from "../../../constants/Roles";
import { tipologieFase } from '../../../constants/TipologiaFase';
import { FaseService } from '../../../services/FaseService';
import { IstruttorieService } from "../../../services/IstruttorieService";
import DatePicker from "../../Form/DatePicker";
import TextArea from "../../Form/TextArea";

export default function GestioneDomande() {

  const toastContext = useContext(ToastContext);

  const [dtOptions, setDtOptions] = useState({});

  const [currMapFilters, setCurrMapFilters] = useState(null);
  const [nextMapFilters, setNextMapFilters] = useState(null);
  const [advancedFiltersMap, setAdvancedFiltersMap] = useState(null);
  const [nextAdvancedFiltersMap, setNextAdvancedFiltersMap] = useState(null);

  const location = useLocation();
  const navigation = useNavigate();

  const [firstLoad, setFirstLoad] = useState(false);
  const [inDownloadPdf, setInDownloadPdf] = useState(false);

  const [avviso, setAvviso] = useState(null);
  const [fase, setFase] = useState(null);
  const [comune, setComune] = useState(null);
  const [statoRichiesta, setStatoRichiesta] = useState(null);
  const [comuni, setComuni] = useState([]);
  const statiRichiesta = [
    { value: "Presentata", key: "PRESENTATA" },
    { value: "Rettificata", key: "AGGIORNATA" },
    { value: "Idonea", key: "IDONEA" },
    { value: "Non idonea", key: "NON_IDONEA" },
    { value: "Finanziabile", key: "FINANZIABILE" },
    /*{ value: "Finanziabile terzo accesso", key: "FINANZIABILE_TERZO_ACCESSO" },*/
    { value: "Non finanziabile", key: "NON_FINANZIABILE" },
    /*{ value: "Non finanziabile terzo accesso", key: "NON_FINANZIABILE_TERZO_ACCESSO" },*/
    { value: "Sospesa", key: "SOSPESA" },
    { value: "Rinunciata", key: "RINUNCIATA" },
    { value: "Ammessa al contributo", key: "AMMESSA_CONTRIBUTO" },
    { value: "Non ammessa al contributo", key: "NON_AMMESSA_CONTRIBUTO" },
    { value: "Contributo erogato", key: "CONTRIBUTO_EROGATO" }
  ];

  const esitiIstruttoria = [{ key: 'POSITIVO' }, { key: 'NEGATIVO' }];
  const ucsCorrette = useRef([]);
  const istruttoriaArs = useRef({});
  const validate = useRef(false);
  const inputErrors = useRef([]);
  const [buttonDelete, setButtonDelete] = useState(null);

  const [avvisi, setAvvisi] = useState(null);
  const [fasi, setFasi] = useState(null);

  const bandoService = new BandoService();
  const faseService = new FaseService();
  const richiestaService = new RichiestaService();
  const emailService = new EmailService();
  const istruttoriaService = new IstruttorieService();
  const utility = new FormUtility();

  const [isModalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState(null);
  const [icona, setIcona] = useState(null);
  const [iconaColor, setIconaColor] = useState(null);
  const [content, setContent] = useState(null);
  const [hideActionButton, setHideActionButton] = useState(false);
  const [actionLabelName, setActionLabelName] = useState(null);
  const [actionModal, setActionModal] = useState(null);
  const [disabledConfirmBtn, setDisabledConfirmBtn] = useState(false);
  const [disableCloseBtn, setDisableCloseBtn] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(null);

  const [domandaId, setDomandaId] = useState(null);
  const [esitoDomanda, setEsitoDomanda] = useState(null);
  const [isLoadingCheckIban, setIsLoadingCheckIban] = useState(false);
  const [isLoadingCheckArs, setIsLoadingCheckArs] = useState(false);
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [hasError, setHasError] = useState(false);
  const formRef = useRef({});

  const [showButtonMassiveRettificaEmails, setShowButtonMassiveRettificaEmails] = useState(false);
  const [showButtonMassiveSecondoAccessoEmails, setShowButtonMassiveSecondoAccessoEmails] = useState(false);
  const [showButtonMassiveRettificaIbanEmails, setShowButtonMassiveRettificaIbanEmails] = useState(false);
  const [showButtonMassiveTerzoAccessoEmails, setShowButtonMassiveTerzoAccessoEmails] = useState(false);

  const [fasePresentazioneDomanda, setFasePresentazioneDomanda] = useState(null);

  const tipologiePresentazione = [tipologieFase.presentazione_domande, tipologieFase.riapertura_presentazione];

  const pollingInterval = useRef(null);
  const dtRef = useRef();

  const condizioniStudente = [
    { key: 'AMMESSO', value: 'Ammesso alla classe successiva per l’A.S. :annoEducativo (promosso)' },
    { key: 'NON_AMMESSO', value: 'Non ammesso alla classe successiva per l’A.S. :annoEducativo (respinto)' },
    { key: 'ATTESA_ASSEGNAZIONE', value: 'In attesa di assegnazione dell’istituto/tipologia di scuola, mi impegno a comunicare al terzo accesso la scuola a cui è iscritto lo studente beneficiario' },
    { key: 'SOSPENSIONE_DEL_GIUDIZIO', value: 'Sospensione del giudizio fino a settembre :soloAnnoEducativo (rimandato), mi impegno a comunicare al terzo accesso la scuola a cui è iscritto lo studente beneficiario' },
    { key: 'MOBILITA_FORMATIVA', value: 'Mobilità formativa, mi impegno a comunicare al terzo accesso la scuola a cui è iscritto lo studente beneficiario' }
  ];

  useEffect(() => {
    bandoService.getAll().then((resp) => {
      setAvvisi(resp);
    });

    const comuni = [...tuttiComuni].filter(
      (el) => el.denominazione_regione === "Toscana"
    );

    setComuni(
      comuni.sort((a, b) => a.denominazione.localeCompare(b.denominazione))
    );

    setFirstLoad(true);
    const filtri = utility.getFiltriAvanzatiStorage(
      location,
      "_filtri_avanzati"
    );
    setOnLoadFiltriAvanzatiFromStorage(filtri, comuni);
    setNextMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());
    setCurrMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());

    richiestaService
      .downloadEsportazioneDomande()
      .then((data) => {
        switch (data?.status) {
          case 'FINITO':
            console.log("Esportazione completata");
            downloadFile(data.blobBase64);
            break;
          case 'IN_CORSO':
            restartPolling();
            break;
          default:
            return;
        }
      })
      .catch((err) => {
        switch (err.response?.status) {
          case 404:
            console.log("Nessuna esportazione in corso");
            break;
          default:
            startPollingDownloadExport();
            break;
        }
      });

		return () => {
      clearInterval(pollingInterval.current);
      pollingInterval.current = null;
		}
  }, []);

  useEffect(() => {
    if (!avvisi || !avviso || !fase || !fasi) {
      return;
    }

    const phase = parseInt(fase);
    const presentazioneDomanda = fasi.find(f => f.id === phase);

    const bando = avvisi.find(a => a.id === parseInt(avviso));
    const faseIsee = bando?.fasi?.find(f => f.tipologia === tipologieFase.aggiornamento_isee && f.raccoltaDomande?.id === phase);
    const faseIseeActive = faseIsee && faseIsee.dataFine && moment(faseIsee.dataFine).isAfter(moment());
    const faseSecondoAccesso = bando?.fasi?.find(f => f.tipologia === tipologieFase.secondo_accesso_non_ammessi_sospesi && f.raccoltaDomande?.id === phase);
    const faseSecondoAccessoActive = faseSecondoAccesso && faseSecondoAccesso.dataFine && moment(faseSecondoAccesso.dataFine).isAfter(moment());
    const faseTerzoAccesso = bando?.fasi?.find(f => f.tipologia === tipologieFase.terzo_accesso_sospesi && f.raccoltaDomande?.id === phase);
    const faseTerzoAccessoActive = faseTerzoAccesso && faseTerzoAccesso.dataFine && moment(faseTerzoAccesso.dataFine).isAfter(moment());
    const faseRettificaIban = bando?.fasi?.find(f => f.tipologia === tipologieFase.rettifica_iban);
    const faseRettificaIbanActive = faseRettificaIban && faseRettificaIban.dataFine && moment(faseRettificaIban.dataFine).isAfter(moment());

    setFasePresentazioneDomanda(presentazioneDomanda);
    setShowButtonMassiveRettificaEmails(faseIseeActive);
    setShowButtonMassiveSecondoAccessoEmails(faseSecondoAccessoActive);
    setShowButtonMassiveTerzoAccessoEmails(faseTerzoAccessoActive);
    setShowButtonMassiveRettificaIbanEmails(faseRettificaIbanActive);
  }, [avvisi, avviso, fase, fasi]);

  const setOnLoadFiltriAvanzatiFromStorage = (filtri, comuni) => {
    const filtriAvanzati = advancedFiltersMap ?? new Map();
    const proxMappaFiltri = new Map(nextMapFilters);
    const proxMappaFiltriAvanzati = new Map(nextAdvancedFiltersMap);

    for (const key in filtri) {
      const value = filtri[key];

      let filterValue = value;
      let filtroAvanzato = value;
      switch (key) {
        case "Comune residenza":
          filterValue = comuni?.find((x) => x.denominazione === value)?.id;
          break;
        case "Stato domanda":
          filtroAvanzato = statiRichiesta?.find((x) => x.key === value)?.value;
          break;
        default:
          break;
      }

      onChangeFilter(key, filterValue, proxMappaFiltri, proxMappaFiltriAvanzati, false);
      filtriAvanzati.set(key, filtroAvanzato);
    }

    setNextAdvancedFiltersMap(new Map(filtriAvanzati));
    setAdvancedFiltersMap(new Map(filtriAvanzati));
  };

  const setFiltriAvanzatiInStorage = (mapFilters) => {
    const obj = Object.fromEntries(mapFilters);
    sessionStorage.setItem(
      `${location.pathname}_filtri_avanzati`,
      JSON.stringify(obj)
    );
  };

  const onChangeFilter = async (type, val, mappaFiltri, mappaFiltriAvanzati, updateNextMap = true, updateMap = false) => {
    let mapValue = val;
    let mapAvanzatoValue = val;

    switch (type) {
      case "Avviso":
        setAvviso(val);
        if (val) {
          const phases = await faseService.getAllByBandoId(val);
          setFasi(phases.filter(f => tipologiePresentazione.includes(f.tipologia)));

          istruttoriaService.getAllUcsByBandoId(val).then(resp => {
            ucsCorrette.current = [
              ...[...new Set(resp.map(el => el.contributo))]
                .sort((a, b) => a - b)
                .map(v => ({ key: v, value: v + ' €' }))
            ];
          });
        }
        if (updateMap) {
          setFase(null);
        }
        break;
      case "Fase":
        setFase(val);
        break;
      case "Comune residenza":
        setComune(!isNaN(val) ? val : comuni.find((x) => x.denominazione === val)?.id);
        break;
      case "Stato domanda":
        mapValue = val ? val === 'AGGIORNATA' ? 'RETTIFICATA' : val : null;
        mapAvanzatoValue = statiRichiesta?.find((x) => x.key === val)?.value;
        setStatoRichiesta(val);
        break;
      default:
        break;
    }

    if (!mapValue) {
      mappaFiltri.delete(type);
      mappaFiltriAvanzati.delete(type);
    } else {
      mappaFiltri.set(type, mapValue);
      mappaFiltriAvanzati.set(type, mapAvanzatoValue);
    }

    if (updateNextMap) {
      setNextMapFilters(new Map(mappaFiltri));
      setNextAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
    }

    if (!updateMap) {
      return;
    }

    setCurrMapFilters(new Map(mappaFiltri));
    setAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
    setFiltriAvanzatiInStorage(new Map(mappaFiltri));
  };

  const gotoVisualizzaDomanda = (domandaId) => {
    navigation(`/gestione-richiesta/${domandaId}`);
  };

  const downloadPdf = async (row) => {
    row.isInDownload = true;
    setInDownloadPdf(true); //mi serve per far ricaricare la pagina
    const response = await richiestaService.downloadPdf(row.id);
    utility.downloadFile(response.data, `richiesta_${row.codice}.pdf`);
    setInDownloadPdf(false); //mi serve per far ricaricare la pagina
    row.isInDownload = false;
  };

  const downloadIsee = async (domandaId, richiestaCodice) => {
    const response = await richiestaService.downloadIsee(domandaId);
    utility.downloadFile(response.data, `risposta_isee_${richiestaCodice}.xml`);
  };

  const checkIsee = async (domandaId) => {
    await richiestaService.checkIsee(domandaId);
    setEsitoDomanda(null);
    toastContext.success("Controllo ISEE richiesto");
    setModalOpen(false);
    dtRef.current.rerenderDatatable();
    setDomandaId(null);
    setEsitoDomanda(null);
    setIcona(null);
    setIconaColor(null);
    setTitle(null);
  };

  const closeModal = async () => {
    setModalOpen(false);
    setDomandaId(null);
    setEsitoDomanda(null);
    setIcona(null);
    setIconaColor(null);
    setTitle(null);
  };

  const openIseeModal = (row) => {
    let esito = row.esitoIsee;
    let esitoIsee =
      esito == "OK" ? "Esito ISEE positivo" : "Esito ISEE negativo";
    let icona = esito == "OK" ? "solid--face-smile" : "solid--face-frown";
    const iconaColor =
      esito == "OK" ? "rtds-text-success-dark" : "rtds-text-warn-dark";

    const hasTechnicalError =
      row.erroriIsee &&
      row.erroriIsee.some((errore) => errore.tipo === "TECHINCAL");

    if (hasTechnicalError) {
      icona = "solid--exclamation-triangle";
      esitoIsee = "Errore tecnico";
    }

    setDomandaId(row.id);
    setActionModal(() => () => checkIsee(row.id));
    setEsitoDomanda(esito);
    setIcona(icona);
    setIconaColor(iconaColor);
    setTitle(esitoIsee);
    setHideActionButton(false);
    setButtonDelete(null);
    setActionLabelName("Riesegui il controllo ISEE");
    setContent(
      <div>
        <section aria-labelledby="elencoErrori">
          {esito == "KO" ? (
            <>
              <section aria-labelledby="elencoErrori">
                <h3 id="elencoErrori" className="rtds-heading-5">
                  Lista errori ISEE:{" "}
                </h3>
                <ul>
                  {row.erroriIsee.map((errore, index) => (
                    <li key={errore.codice}>
                      &#x2022;&nbsp;{errore.descrizione}
                    </li>
                  ))}
                </ul>
              </section>
              <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>
            </>
          ) : null}
        </section>

        {row.rispostaIsee && (
          <button
            onClick={() => downloadIsee(row.id, row.codice)}
            className="rtds-btn rtds-btn--only-text "
          >
            Scarica XML
            <svg
              className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 rtds-transition-all rtds-duration-200 rtds-ease-out rtds-transform group-hover:rtds-translate-x-1"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use href="../../icons.svg#solid--arrow-down-tray"></use>
            </svg>
          </button>
        )}
      </div>
    );

    setModalOpen(true);
  };

  const openArsModal = (row) => {
    setDefaultModalOpenValues();

    const condizioneStudente = condizioniStudente.find(el => el.key === row.condizioneStudente)
                                ?.value
                                .replace(':annoEducativo', row.annoEducativo)
                                .replace(':soloAnnoEducativo', row.annoEducativo.substring(0, 4)) ?? '-';

    const colorAlert = utility.colorClassAlertArsMap[row.esitoCheckArs];

    setIcona(utility.iconClassArsMap[row.esitoCheckArs]);
    setIconaColor(`${utility.colorClassBtnArsMap[row.esitoCheckArs]} rtds-rounded-full rtds-p-1`);

    setTitle("Esito Controllo ARS");
    setHideActionButton(true);
    setButtonDelete(null);
    setActionLabelName(null);
    setContent(
      <div>
        <section aria-labelledby="checkArs">
          <div className="rtds-flex rtds-justify-between">
            <p>
              CF Beneficiario: <strong>{row.codiceFiscaleBeneficiario}</strong>
            </p>

            <p>
              Codice Domanda: <strong>{row.codice}</strong>
            </p>

            <p>
              Data Controllo: <strong>{moment(row.dataUltimaModificaCheckArs).format("DD/MM/YYYY HH:mm:ss")}</strong>
            </p>
          </div>
          <section className={`rtds-note ${colorAlert} rtds-my-6`}>
            <div className="rtds-note__content rtds-divide-y rtds-divide-gray-01">
              <div className="rtds-note__content-item">
                <p className="rtds-note__content-item-description font-bold">
                  {row.messaggioCheckArs}
                </p>
              </div>
            </div>
          </section>

          <table className="min-w-full rtds-bg-white table-auto table">
            <caption className="rtds-heading-4 rtds-text-left rtds-p-3 rtds-content-02">
              Dati Studente Beneficiario
            </caption>
            <thead>
              <tr className="rtds-background-03">
                <th scope="col" className=" rtds-p-3 ">Condizione studente</th>
                <th scope="col" className=" rtds-p-3 ">Ordine e grado</th>
                <th scope="col" className=" rtds-p-3 ">Classe</th>
                <th scope="col" className=" rtds-p-3 ">Istituzione</th>
                <th scope="col" className=" rtds-p-3 ">Plesso</th>
                <th scope="col" className=" rtds-p-3 ">Indirizzo di studio</th>
              </tr>
            </thead>
            <tbody className="rtds-content-01 rtds-text-sm">
              <tr key={row.id}>
                <td className=" rtds-p-2 rtds-border-gray-02 sx-word-break ">
                  {condizioneStudente}
                </td>
                <td className=" rtds-p-2 rtds-border-gray-02 sx-word-break ">
                  {utility.getOrdineName(row.ordineGrado)}
                </td>
                <td className=" rtds-p-2 rtds-border-gray-02 sx-word-break ">
                  {row.annoCorso}
                </td>
                <td className=" rtds-p-2 rtds-border-gray-02 sx-word-break ">
                  {row.codiceIstituto ? (row.codiceIstituto + " - " + row.denominazioneIstituto) : '-'}
                </td>
                <td className=" rtds-p-2 rtds-border-gray-02 sx-word-break ">
                  {row.codicePlesso ? (row.codicePlesso + " - " + row.denominazionePlesso) : '-'}
                </td>
                <td className=" rtds-p-2 rtds-border-gray-02 sx-word-break ">
                  {row.codiceIndirizzoDiStudio
                    ? row.codiceIndirizzoDiStudio +
                      ' - ' +
                      row.denominazioneIndirizzoDiStudio
                    : '-'}
                </td>
              </tr>
            </tbody>
          </table>

          {
            !['DATI_INVALIDI'].includes(row.esitoCheckArs) &&
            row.carriereArs.length > 0 &&
            <>
              <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

              <table className="min-w-full rtds-bg-white table-auto table">
                <caption className="rtds-heading-4 rtds-text-left rtds-p-3 rtds-content-02">
                  Dati ARS - Anagrafe Regionale Studenti
                </caption>

                <thead>
                  <tr className="rtds-background-03">
                    <th className="rtds-p-3">A.S.</th>
                    <th className="rtds-p-3">Stato</th>
                    <th className="rtds-p-3">Data variaz. stato</th>
                    <th className="rtds-p-3">Esito</th>
                    <th className="rtds-p-3">Ordine</th>
                    <th className="rtds-p-3">Classe</th>
                    <th className="rtds-p-3">Istituzione</th>
                    <th className="rtds-p-3">Plesso</th>
                    <th className="rtds-p-3">Indirizzo di studio</th>
                  </tr>
                </thead>

                <tbody className="rtds-content-01 rtds-text-sm">
                  {row.carriereArs
                    .sort((a, b) => b.anno_scolastico - a.anno_scolastico)
                    .map((carriera) => (
                    <tr key={carriera.id}>
                      <td className="rtds-p-2 rtds-border-gray-02 sx-word-break">
                        {`${carriera.anno_scolastico.slice(
                          0,
                          4
                        )}/${carriera.anno_scolastico.slice(4)}`}
                      </td>
                      <td className="rtds-p-2 rtds-border-gray-02 sx-word-break">
                        {carriera.stato_alunno_descrizione}
                      </td>
                      <td className="rtds-p-2 rtds-border-gray-02 sx-word-break">
                        {carriera.data_variazione_stato
                          ? moment(carriera.data_variazione_stato).format(
                              "DD/MM/YYYY"
                            )
                          : "-"}
                      </td>
                      <td className="rtds-p-2 rtds-border-gray-02 sx-word-break">
                        {carriera.esito_alunno_descrizione}
                      </td>
                      <td className="rtds-p-2 rtds-border-gray-02 sx-word-break">
                        {utility.getOrdineName(carriera.ordine, false)}
                      </td>
                      <td className="rtds-p-2 rtds-border-gray-02 sx-word-break">
                        {carriera.classe_frequenza}
                      </td>
                      <td className="rtds-p-2 rtds-border-gray-02 sx-word-break">
                        {carriera.codice_istituto +
                          " - " +
                          carriera.denominazione_istituto}
                      </td>
                      <td className="rtds-p-2 rtds-border-gray-02 sx-word-break">
                        {carriera.codice_plesso +
                          " - " +
                          carriera.denominazione_plesso}
                      </td>
                      <td className="rtds-p-2 rtds-border-gray-02 sx-word-break">
                        {carriera.codice_indirizzo_di_studio
                          ? carriera.codice_indirizzo_di_studio +
                            " - " +
                            carriera.denominazione_indirizzo_di_studio
                          : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          }
          
        </section>
      </div>
    );

    setModalOpen(true);
  };

  const openIstruttoriaArsModal = (row) => {
    setDefaultModalOpenValues();

    setIcona(utility.iconClassIstruttoriaArsMap[row.esitoIstruttoriaArs]|| 'outline--minus-circle');

    setIconaColor(`${utility.colorClassBtnIstuttoriaArsMap[row.esitoIstruttoriaArs]} rtds-rounded-full rtds-p-1`);

    const istruttoria = {
      idIstruttoriaArs: row.idIstruttoriaArs,
      dataIstruttoriaArs: row.dataIstruttoriaArs,
      noteIstruttoriaArs: row.noteIstruttoriaArs,
      esitoIstruttoriaArs: row.esitoIstruttoriaArs,
      ucsCorretta: row.ucsCorretta,
      richiestaId: row.id
    };
    istruttoriaArs.current = istruttoria;

    setTitle("Istruttoria Esito ARS");
    setHideActionButton(false);
    setActionLabelName('Salva');
    setActionModal(() => () => saveIstruttoriaArs(row, istruttoria));

    setButtonDelete(
      row.idIstruttoriaArs
        ? <button
            disabled={disabledConfirmBtn}
            type="button"
            className="rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--secondary"
            onClick={() => deleteIstruttoriaArs(row.idIstruttoriaArs)}
            hidden={hideActionButton}
          >
            <span>{"Rimuovi istruttoria"}</span>
            <span className="rtds-sr-only">
              di {title || "Titolo modale"}
            </span>
            {!confirmLoading && (
              <svg
                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                aria-hidden="true"
                focusable="false"
                role="img"
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--trash`}
                />
              </svg>
            )}
          </button>
        : null
    );

    setContent(
      renderIstruttoriaArsModalContent(row, istruttoria)
    );

    setModalOpen(true);
  };

  const setDefaultModalOpenValues = () => {
    inputErrors.current = [];
    validate.current = false;
  }

  const renderIstruttoriaArsModalContent = (row, istruttoriaArs) => {
    return (
      <div>
        <section aria-labelledby="istruttoriaArs">
          <div className="rtds-grid rtds-grid-cols-3 xs:rtds-grid-cols-3 sm:rtds-grid-cols-2 md:rtds-grid-cols-2 lg:rtds-grid-cols-3 xl:rtds-grid-cols-3 2xl:rtds-grid-cols-3 3xl:rtds-grid-cols-3 rtds-gap-3">
            <div className="rtds-grid rtds-items-center">
              <p>
                CF Beneficiario:{" "}
                <br/><strong>{row.codiceFiscaleBeneficiario}</strong>
              </p>
            </div>

            <div className=" rtds-grid rtds-items-center ">
              <p>
                Codice Domanda: <br/><strong>{row.codice}</strong>
              </p>
            </div>

            <div className="  rtds-grid rtds-items-center ">
              <p>
                Email Richiedente: <br/><strong>{row.emailDatiUtente}</strong>
              </p>
            </div>
          </div>
          <div className="rtds-grid rtds-gap-3 ">
            <div className="">
              {" "}
              <p>
                Esito ARS:{" "}
                <br/><strong>
                  {row.istitutoInToscana === false
                    ? "Studente frequentante una scuola fuori regione"
                    : row.messaggioCheckArs}
                </strong>
              </p>
            </div>
          </div>

          <section>
            <form
              noValidate
              ref={formRef}
              id="hasValidationForm"
              className="has-js-validation-form rtds-py-6 rtds-space-y-4"
            >
              <div className="rtds-field-row">
                <DatePicker
                  required
                  label={"Data istruttoria "}
                  id={"dataIstruttoriaArs"}
                  inputErrors={inputErrors.current}
                  classInput={"rtds-text-sm rtds-input-placeholder"}
                  type={"date"}
                  onInput={(event) =>
                    onChangeIstruttoria(
                      event,
                      row,
                      istruttoriaArs,
                      "dataIstruttoriaArs"
                    )
                  }
                  hideSubTitle
                  max={"9999-12-31"}
                  defaultValue={
                    istruttoriaArs.dataIstruttoriaArs
                      ? moment(istruttoriaArs.dataIstruttoriaArs).format(
                          "YYYY-MM-DD"
                        )
                      : ""
                  }
                  errorMessage={
                    validate.current && !istruttoriaArs.dataIstruttoriaArs
                      ? "Campo obbligatorio"
                      : ""
                  }
                />

                <Select
                  classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                  label={"Esito istruttoria"}
                  required
                  id={"esitoIstruttoriaArs"}
                  inputErrors={inputErrors.current}
                  classSelect={""}
                  onChange={(event) =>
                    onChangeIstruttoria(
                      event,
                      row,
                      istruttoriaArs,
                      "esitoIstruttoriaArs"
                    )
                  }
                  baseOption={"Seleziona esito"}
                  options={esitiIstruttoria}
                  bindValue={"key"}
                  value={istruttoriaArs.esitoIstruttoriaArs || ""}
                />
              </div>
              <div className="">
                <TextArea
                  label={"Note istruttoria"}
                  id={"noteIstruttoriaArs"}
                  classTextArea={
                    "rtds-text-sm rtds-input-placeholder"
                  }
                  type={"text"}
                  onChange={(event) =>
                    onChangeIstruttoria(
                      event,
                      row,
                      istruttoriaArs,
                      "noteIstruttoriaArs"
                    )
                  }
                  value={istruttoriaArs.noteIstruttoriaArs || ""}
                  maxLength={500}
                  style={{ height: "67px" }}
                />
              </div>
              <div className="rtds-field-row">
                <Select
                  classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                  label={"UCS definitiva"}
                  required
                  id={"ucsCorretta"}
                  inputErrors={inputErrors.current}
                  classSelect={""}
                  onChange={(event) =>
                    onChangeIstruttoria(
                      event,
                      row,
                      istruttoriaArs,
                      "ucsCorretta"
                    )
                  }
                  baseOption={"Seleziona ucs"}
                  options={ucsCorrette.current}
                  bindValue={"value"}
                  value={istruttoriaArs.ucsCorretta || ""}
                />
              </div>
            </form>
          </section>
        </section>
      </div>
    );
  }

  const onChangeIstruttoria = (event, row, istruttoriaArsDati, name) => {
    const istruttoria = { ...istruttoriaArsDati, [name]: event.target.value };
    istruttoriaArs.current[name] = event.target.value;

    if (validate) {
      setFormErrors(false);
    }

    setContent(
      renderIstruttoriaArsModalContent(row, istruttoria, ucsCorrette)
    );
  }

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    inputErrors.current = errors.map((el) => el.id);
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const saveIstruttoriaArs = (row, newIstruttoria) => {
    validate.current = true;

    const validity = formRef.current.checkValidity();
    if (!validity) {
      setFormErrors();

      setContent(
        renderIstruttoriaArsModalContent(row, newIstruttoria, ucsCorrette)
      );

      return;
    }

    inputErrors.current = [];

    istruttoriaService.saveIstruttoriaArs(
      {
        id: istruttoriaArs.current.idIstruttoriaArs,
        esitoIstruttoria: istruttoriaArs.current.esitoIstruttoriaArs,
        dataIstruttoria: istruttoriaArs.current.dataIstruttoriaArs,
        noteIstruttoria: istruttoriaArs.current.noteIstruttoriaArs,
        ucsCorretta: istruttoriaArs.current.ucsCorretta,
        richiestaId: istruttoriaArs.current.richiestaId
      }
    ).then(() => {
      validate.current = false;
      setModalOpen(false);
      toastContext.success("Salvataggio istruttoria ARS completato");
      dtRef.current.rerenderDatatable();
      setButtonDelete(null);
    }, error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
  }

  const deleteIstruttoriaArs = (idIstruttoriaArs) => {
    if (!window.confirm('Sei sicuro di voler rimuovere l\'istruttoria ARS da questa richiesta?')) {
      return;
    }

    istruttoriaService.deleteIstruttoriaArs(idIstruttoriaArs).then(() => {
      setModalOpen(false);
      toastContext.success("Rimozione istruttoria ARS completato");
      dtRef.current.rerenderDatatable();
      setButtonDelete(null);
    }, error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    })
  }

  const openProtocolModal = (row) => {
    const esito = row.esitoProtocollo;
    const esitoProtocollo =
      esito === "OK"
        ? "Esito Protocollo positivo"
        : "Esito Protocollo negativo";
    const icona =
      esito === "OK" ? "solid--paper-clip" : "solid--exclamation-triangle";
    const iconaColor =
      esito === "OK" ? "rtds-text-success-dark" : "rtds-text-warn-dark";
    setDomandaId(row.id);
    setActionModal(() => () => checkIsee(row.id));
    setEsitoDomanda(esito);
    setIcona(icona);
    setIconaColor(iconaColor);
    setTitle(esitoProtocollo);
    setHideActionButton(true);
    setButtonDelete(null);
    setContent(
      <div>
        <section aria-labelledby="areaProtocollo">
          {esito === "KO" ? (
            <p>Non è stato possibile ottenere il protocollo</p>
          ) : esito === "OK" ? (
            <>
              <p>
                <strong>Numero Protocollo:</strong> {row.numeroProtocollo}
              </p>
              <p>
                <strong>Data Protocollo:</strong>{" "}
                {moment(new Date(parseInt(row.dataProtocollo))).format(
                  "DD/MM/YYYY HH:mm:ss"
                )}
              </p>
            </>
          ) : null}
        </section>
      </div>
    );

    setModalOpen(true);
  };

  const downloadIbanResponse = async (richiestaId, richiestaCodice) => {
    const response = await richiestaService.downloadControlloIban(richiestaId);
    utility.downloadFile(response.data, `risposta_iban_${richiestaCodice}.json`);
  }

  const openCheckIbanModal = (row) => {
    let titleText = "";
    switch(row.checkIbanOrdinamento){
      case 0:
        titleText = `IBAN e CF del richiedente non trovati`;
        break;
      case 1:
        titleText = `${row.checkIbanCodiceErrore} - PSP Not Present in Routing Subsystem`;
        break;
      case 2:
        titleText = `${row.checkIbanCodiceErrore} - Invalid IBAN code`;
        break;
      case 3:
        const obj = JSON.parse(row.checkIbanRisposta);
        const description = obj.errors[0].description;
        titleText = `${row.checkIbanCodiceErrore} - ${description}`;
        break;
      case 4:
        titleText = `L'IBAN è associato al CF del richiedente`;
        break;
      default:
        break;
    }
    const iconName =
    row.checkIbanOrdinamento === 0
      ? "solid--x-mark " //KO
      : row.checkIbanOrdinamento === 1
      ? "solid--building-library " //Banca non convenzionata
      : row.checkIbanOrdinamento === 2
      ? "solid--no-symbol " //IBAN non valido
      : row.checkIbanOrdinamento === 3
      ? "solid--exclamation-triangle " //KO tecnici generici
      : row.checkIbanOrdinamento === 4
      ? "solid--check-badge " //OK
      : "solid--minus "; // icona di default
    const buttonClassName = `rtds-btn rtds-btn--icon  ${
        row.checkIbanOrdinamento === 0
          ? "rtds-btn--danger "
          : row.checkIbanOrdinamento === 1
          ? "rtds-btn--warn "
          : row.checkIbanOrdinamento === 2
          ? "rtds-btn--warn "
          : row.checkIbanOrdinamento === 3
          ? "rtds-btn--warn "
          : row.checkIbanOrdinamento === 4
          ? "rtds-btn--success "
          : ""
      }`;
    setIcona(iconName)
    setIconaColor(buttonClassName)
    setTitle("Esito controllo IBAN");
    setHideActionButton(true);
    setButtonDelete(null);
    setContent(<div>
      <p>{titleText}</p>
      <button
        type="button"
        className="rtds-btn rtds-btn--only-text  "
        onClick={() => {
          downloadIbanResponse(row.id, row.codice);
        }}
        title="Scarica"
        >
          Scarica JSON <svg
              className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 rtds-transition-all rtds-duration-200 rtds-ease-out rtds-transform group-hover:rtds-translate-x-1"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use href="../../icons.svg#solid--arrow-down-tray"></use>
            </svg></button>
    </div>);
    setModalOpen(true);
  }

  const openPagamentoModal = (row) => {
    setHasError(false);
    setIcona("solid--exclamation-circle");
    setIconaColor("rtds-btn rtds-btn--icon rtds-btn--danger");
    setTitle("Modifica esito pagamento");
    setHideActionButton(false);
    setActionLabelName("Conferma pagamento KO");
    setActionModal(() => () => invertiEsitoPagamento(row));
    setContent(renderModalContent(row, false));
    setButtonDelete(null);
    setModalOpen(true);
  }

  const openAnprModal = (row) => {
    const esito = row.anpr;
    const esitoAnpr = row.anprDescrizione;      
    const icona =
                  esito === 0
                  ? 'solid--exclamation-triangle '
                  : esito === 1
                  ? 'solid--x-circle '
                  : esito === 2
                  ? 'solid--exclamation-circle '
                  : esito === 3
                  ? 'solid--check-circle '                
                  : ''; // icona di default

    const iconaColor =
                      esito === 0
                      ? 'rtds-text-warn-dark' // You might want a specific class for technical errors
                      : esito === 1
                      ? 'rtds-text-error-dark'
                      : esito === 2
                      ? 'rtds-text-success-dark'
                      : esito === 3
                      ? 'rtds-text-success-dark'
                      : '';

    setDomandaId(row.id);
    setActionModal(() => () => checkIsee(row.id));
    setEsitoDomanda(esito === 3 || esito ===4);
    setIcona(icona);
    setIconaColor(iconaColor);
    setTitle("Esito controllo ANPR");
    setHideActionButton(true);
    setButtonDelete(null);
    setContent(
      <div>
        <section aria-labelledby="areaAnpr">
            <p>{esitoAnpr}</p>
            { (esito ===1 || esito ===2 || esito ===3  ) &&
            <>
              <p>
                <strong>Codice ISTAT comune:</strong>
                {row.anprCodiceComune}
              </p>
              <p>
                <strong>Denominazione Comune:</strong>{" "}
                {row.anprDenominazioneComune}
              </p>            
              </>
            }
        </section>
      </div>
    );

    setModalOpen(true);
  };

  const getTitleEmail = (row) => {
    return row.esitoEmail === "OK"
      ? row.statoRichiesta === "ANNULLATA"
        ? "Email di conferma annullamento domanda inviata correttamente"
        : "Email di conferma inviata correttamente"
      : row.esitoEmail === "KO"
      ? "Email non inviata o in errore"
      : row.esitoEmail === "WAITING"
      ? "Email in attesa di essere inviata"
      : "Email non inviata";
  };

  useEffect(() => {
    if (!firstLoad || !currMapFilters || !avviso || !fase) {
      return;
    }

    createDtOptions();
  }, [currMapFilters]);

  const createDtOptions = () => {
    const dtOpt = {
      columns: [
        {
          name: "Id",
          data: "id",
          visible: false,
          sortable: false,
          searchable: false,
        },
        {
          name: "Codice pratica",
          data: "codice",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "Stato della domanda",
          data: "statoRichiesta",
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) => (
            <>
              <div className="rtds-justify-between rtds-flex">
                <span className="lg:rtds-hidden rtds-font-semibold">
                  {col.name}
                </span>
                {
                  row.statoRichiesta=='AGGIORNATA'?'RETTIFICATA':
                  (row.statoRichiesta=='SOSPESA_TERZO_ACCESSO')?'SOSPESA':
                  (row.statoRichiesta=='AMMESSA_CONTRIBUTO_RETTIFICATA')?'AMMESSA_CONTRIBUTO':
                  (row.statoRichiesta=='FINANZIABILE_TERZO_ACCESSO')?'FINANZIABILE':
                  (row.statoRichiesta=='FINANZIABILE_RETTIFICATA')?'FINANZIABILE':
                  (row.statoRichiesta=='NON_FINANZIABILE_TERZO_ACCESSO')?'NON_FINANZIABILE':
                  row.statoRichiesta
                }
              </div>
            </>
          ),
        },
        {
          name: "Data della domanda",
          data: "dataDellaDomanda",
          visible: true,
          sortable: true,
          searchable: true,
          //center: true,
          cell: (row, col) => (
            <>
              <div className="rtds-justify-between rtds-flex">
                <span className="lg:rtds-hidden rtds-font-semibold">
                  {col.name}
                </span>
                {
                  moment(row.dataDellaDomanda).format("DD/MM/YYYY HH:mm:ss")
                }
              </div>
            </>
          ),
        },
        {
          name: "C.F. richiedente",
          data: "codiceFiscale",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "C.F. studente",
          data: "codiceFiscaleBeneficiario",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "Comune residenza studente",
          data: "comuneResidenzaDenominazioneBeneficiario",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "Protocollo",
          data: "esitoProtocollo",
          visible: true,
          sortable: true,
          searchable: false,
          //center: true,
          cell: (row, col) => (
            <div className="rtds-justify-between rtds-flex rtds-items-center">
              <span className="lg:rtds-hidden rtds-font-semibold">
                {col.name}
              </span>
              <button
                disabled={!row.esitoProtocollo}
                type="button"
                className={`rtds-btn rtds-btn--icon  ${
                  row.esitoProtocollo === null
                    ? "rtds-button-inverted"
                    : row.esitoProtocollo === "OK"
                    ? "rtds-btn--success"
                    : "rtds-btn--warn"
                }`}
                onClick={() => {
                  openProtocolModal(row);
                }}
                title={
                  row.esitoProtocollo === null
                    ? "In attesa di risposta dal servizio di protocollazione"
                    : row.esitoProtocollo === "OK"
                    ? "Esito Protocollo positivo"
                    : "Esito Protocollo negativo"
                }
              >
                <svg
                  className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 ${
                    row.esitoProtocollo == null ? "rtds-animate-spin" : ""
                  }`}
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${
                      row.esitoProtocollo === null
                        ? "spinner"
                        : row.esitoProtocollo === "OK"
                        ? "solid--paper-clip"
                        : "solid--exclamation-triangle"
                    }`}
                  >
                    {" "}
                  </use>
                </svg>
                <span className="rtds-sr-only">
                  {row.esitoProtocollo === null
                    ? "In attesa"
                    : row.esitoProtocollo === "OK"
                    ? "Esito Protocollo positivo"
                    : "Esito Protocollo negativo"}
                </span>
              </button>
            </div>
          ),
        },
        {
          name: "ISEE",
          data: "esitoIsee",
          visible: true,
          sortable: true,
          searchable: false,
          //center: true,
          cell: (row, col) => {
            const hasTechnicalError =
              row.erroriIsee &&
              row.erroriIsee.some((errore) => errore.tipo === "TECHINCAL");
            const esitoIseeText =
              row.esitoIsee === "OK"
                ? "Esito ISEE positivo"
                : "Esito ISEE negativo";
            const titleText =
              row.esitoIsee === null
                ? "In attesa della risposta dal servizio di verifica ISEE "
                : hasTechnicalError
                ? "Errore tecnico nella verifica ISEE"
                : esitoIseeText;
            const srOnlyText =
              row.esitoIsee === null
                ? "In attesa"
                : hasTechnicalError
                ? "Errore tecnico"
                : row.esitoIsee === "OK"
                ? "Esito positivo"
                : "Esito negativo";
            const iconName =
              row.esitoIsee === null
                ? "spinner"
                : hasTechnicalError
                ? "solid--exclamation-triangle"
                : row.esitoIsee === "OK"
                ? "solid--face-smile"
                : "solid--face-frown";
            const buttonClassName = `rtds-btn rtds-btn--icon  ${
              row.esitoIsee === null
                ? "rtds-button-inverted"
                : hasTechnicalError
                ? "rtds-btn--warn" // You might want a specific class for technical errors
                : row.esitoIsee === "OK"
                ? "rtds-btn--success"
                : "rtds-btn--warn"
            }`;
            const shouldSpin = row.esitoIsee === null;

            return (
              <div
                className="rtds-justify-between rtds-flex rtds-items-center"
                hidden={row.statoRichiesta === "ANNULLATA"}
              >
                <span className="lg:rtds-hidden rtds-font-semibold">
                  {col.name}
                </span>
                <button
                  disabled={!row.esitoIsee && !hasTechnicalError} // Disable if no ISEE result and no technical error
                  type="button"
                  className={buttonClassName}
                  onClick={() => {
                    openIseeModal(row);
                  }}
                  title={titleText}
                >
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 ${
                      shouldSpin ? "rtds-animate-spin" : ""
                    }`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${iconName}`}
                    ></use>
                  </svg>
                  <span className="rtds-sr-only">{srOnlyText}</span>
                </button>
              </div>
            );
          },
        },
        {
          name: "Email di conferma",
          data: "esitoEmail",
          visible: true,
          sortable: true,
          searchable: false,
          //center: true,
          cell: (row, col) => (
            <div
              className="rtds-justify-between rtds-flex rtds-items-center"
              hidden={row.statoRichiesta === "ANNULLATA"}
            >
              <span className="lg:rtds-hidden rtds-font-semibold">
                {col.name}
              </span>
              <div title={getTitleEmail(row)}>
                <svg
                  className={`rtds-icon rtds-fill-current rtds-w-8 rtds-h-8 ${
                    row.esitoEmail === "WAITING" ? "rtds-animate-spin" : ""
                  } ${
                    row.esitoEmail === "OK"
                      ? "rtds-text-info-dark"
                      : row.esitoEmail === "KO"
                      ? "rtds-text-danger-dark"
                      : "rtds-text-neutral-700"
                  }`}
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${
                      row.esitoEmail === "WAITING"
                        ? "spinner"
                        : row.esitoEmail === "OK"
                        ? "solid--envelope"
                        : row.esitoEmail === "KO"
                        ? "solid--exclamation-triangle"
                        : "solid--no-symbol"
                    }`}
                  />
                </svg>
                <span className="rtds-sr-only">{getTitleEmail(row)}</span>
              </div>
            </div>
          ),
        },
        {
          name: "ANPR",
          data: "anpr",
          visible: true,
          sortable: true,
          searchable: false,
          //center: true,
          cell: (row, col) => {
            const titleText = row.anprDescrizione;
            const srOnlyText = row.anprDescrizione;
            const shouldSpin = false;
            const iconName = 
            row.anpr === 0
              ? 'solid--exclamation-triangle '
              : row.anpr === 1
              ? 'solid--x-mark'
              : row.anpr === 2
              ? 'solid--exclamation-circle '
              : row.anpr === 3
              ? 'solid--check '
              : row.anpr === 4
              ? 'solid--minus'
              : ''; // icona di default

            const buttonClassName = `rtds-btn rtds-btn--icon  ${
              row.anpr === 4 
                ? "rtds-button-inverted"
                : row.anpr === 0 
                ? "rtds-btn--warn" // You might want a specific class for technical errors
                : row.anpr === 1 
                ? "rtds-btn--danger" 
                : row.anpr === 2
                ? 'rtds-btn--success '
                : row.anpr === 3
                ? "rtds-btn--success"
                : "rtds-btn--warn"
            }`;
            return (
              <div
                className="rtds-justify-between rtds-flex rtds-items-center"      
                hidden={row.statoRichiesta === "ANNULLATA"}          
              >
                <span className="lg:rtds-hidden rtds-font-semibold">
                  {col.name}
                </span>
                <button
                  disabled={row.anpr  ===4 } // Disable if no ISEE result and no technical error
                  type="button"
                  className={buttonClassName}
                  onClick={() => {
                    openAnprModal(row);
                  }}
                  title={titleText}
                >
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 ${
                      shouldSpin ? "rtds-animate-spin" : ""
                    }`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${iconName}`}
                    ></use>
                  </svg>
                  <span className="rtds-sr-only">{srOnlyText}</span>
                </button>
              </div>
            );
          },
        },
        {
          name: "IBAN",
          data: "checkIbanOrdinamento",
          visible: true,
          sortable: true,
          searchable: false,
          //center: true,
          cell: (row, col) => {
            let titleText = "";
            switch(row.checkIbanOrdinamento){
              case 0:
                titleText = `IBAN e CF del richiedente non corrispondono`;
                break;
              case 1:
                titleText = `${row.checkIbanCodiceErrore} - PSP Not Present in Routing Subsystem`;
                break;
              case 2:
                titleText = `${row.checkIbanCodiceErrore} - Invalid IBAN code`;
                break;
              case 3:
                const obj = JSON.parse(row.checkIbanRisposta);
                const description = obj?.errors[0]?.description;
                titleText = `${row.checkIbanCodiceErrore} - ${description}`;
                break;
              case 4:
                titleText = `L'IBAN è associato al CF del richiedente`;
                break;
            }
            const shouldSpin = false;
            const iconName =
              row.checkIbanOrdinamento === 0
                ? "solid--x-mark " //KO
                : row.checkIbanOrdinamento === 1
                ? "solid--building-library " //Banca non convenzionata
                : row.checkIbanOrdinamento === 2
                ? "solid--no-symbol " //IBAN non valido
                : row.checkIbanOrdinamento === 3
                ? "solid--exclamation-triangle " //KO tecnici generici
                : row.checkIbanOrdinamento === 4
                ? "solid--check-badge " //OK
                : "solid--minus "; // icona di default

            const buttonClassName = `rtds-btn rtds-btn--icon  ${
              row.checkIbanOrdinamento === 0
                ? "rtds-btn--danger "
                : row.checkIbanOrdinamento === 1
                ? "rtds-btn--warn "
                : row.checkIbanOrdinamento === 2
                ? "rtds-btn--warn "
                : row.checkIbanOrdinamento === 3
                ? "rtds-btn--warn "
                : row.checkIbanOrdinamento === 4
                ? "rtds-btn--success "
                : ""
            }`;
            return (
              <div
                className="rtds-justify-between rtds-flex rtds-items-center"
                hidden={row.statoRichiesta === "ANNULLATA"}
              >
                <span className="lg:rtds-hidden rtds-font-semibold">
                  {col.name}
                </span>
                <button
                  disabled={row.checkIbanOrdinamento == null }
                  type="button"
                  className={buttonClassName}
                  onClick={() => {
                    // 
                    openCheckIbanModal(row);
                  }}
                  title={titleText}
                >
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 ${
                      shouldSpin ? "rtds-animate-spin" : ""
                    }`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${iconName}`}
                    ></use>
                  </svg>
                  <span className="rtds-sr-only">{titleText}</span>
                </button>
              </div>
            );
          },
        },
        {
          name: "ARS",
          data: "esitoCheckArs",
          visible: true,
          sortable: true,
          searchable: false,
          //center: true,
          cell: (row, col) => {
            const testoEsito = !row.esitoCheckArs ? "Nessun esito" : row.messaggioCheckArs;

            const buttonClassName = `rtds-btn rtds-btn--icon ${
              utility.colorClassBtnArsMap[row.esitoCheckArs] ?? ""
            }`;

            return (
              <div
                className="rtds-justify-between rtds-flex rtds-items-center"
              >
                <span className="lg:rtds-hidden rtds-font-semibold">
                  {col.name}
                </span>
                <button
                  type="button"
                  disabled={!row.esitoCheckArs}
                  className={buttonClassName}
                  onClick={() => {
                    openArsModal(row);
                  }}
                  title={row.esitoCheckArs ? 'Premere per leggere la motivazione dell\'esito' : 'Nessun esito da mostrare'}
                >
                   <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${utility.iconClassArsMap[row.esitoCheckArs] ?? 'solid--minus'}`}
                    ></use>
                  </svg>
                  <span className="rtds-sr-only">{testoEsito}</span>
                </button>
              </div>
            );
          },
        },
        {
          name: "Istruttoria ARS",
          data: "esitoIstruttoriaArs",
          visible: true,
          sortable: true,
          searchable: false,
          //center: true,
          cell: (row, col) => {
            const testoIstruttoria = !row.esitoIstruttoriaArs ? "Nessuna istruttoria" : 'POSITIVO' === row.esitoIstruttoriaArs? "Istruttoria esito positivo" : "Istruttoria esito negativo";

            const buttonClassName = `rtds-btn rtds-btn--icon ${
              utility.colorClassBtnIstuttoriaArsMap[row.esitoIstruttoriaArs] ?? ""
            }`;

            return (
              <div
                className="rtds-justify-between rtds-flex rtds-items-center"
              >
                <span className="lg:rtds-hidden rtds-font-semibold">
                  {col.name}
                </span>
                <button
                  type="button"
                  className={buttonClassName}
                  onClick={() => {
                    openIstruttoriaArsModal(row);
                  }}
                  title={row.esitoIstruttoriaArs ? 'Premere per visualizzare l\'istruttoria' : 'Premere per inserire l\'istruttoria'}
                >
                   <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${utility.iconClassIstruttoriaArsMap[row.esitoIstruttoriaArs] ?? 'solid--minus'}`}
                    ></use>
                  </svg>
                  <span className="rtds-sr-only">{testoIstruttoria}</span>
                </button>
              </div>
            );
          },
        },
        {
          name: "Pagamento",
          data: "esitoPagamento",
          visible: true,
          sortable: true,
          searchable: false,
          cell: (row, col) => {
            let titleText = "";
            let iconName = "";
            let buttonClassName = "rtds-btn rtds-btn--icon ";

            switch (row.esitoPagamento) {
              case "0": // Pagamento KO
                titleText = row.motivazioneKoPagamento;
                iconName = "solid--exclamation-circle ";
                buttonClassName += "rtds-btn--danger ";
                break;
              case "1": // Pagamento OK
                titleText = "Pagamento andato a buon fine";
                iconName = "solid--currency-euro ";
                buttonClassName += "rtds-btn--success ";
                break;
              default:
                titleText = "Pagamento non ancora eseguito";
                iconName = "solid--minus ";
                buttonClassName += "rtds-background-01 rtds-border-gray-01 rtds-text-neutral-600";
                break;
            }

            const shouldSpin = false;

            return (
              <div
                className="rtds-justify-between rtds-flex rtds-items-center"
                hidden={row.statoRichiesta === "ANNULLATA"}
              >
                <span className="lg:rtds-hidden rtds-font-semibold">
                  {col.name}
                </span>
                <button
                  type="button"
                  disabled={!row.esitoPagamento || row.esitoPagamento == '0'}
                  className={`${buttonClassName} ${row.esitoPagamento === '0' ? 'esitoKo' : ''}`}
                  onClick={() => {
                    openPagamentoModal(row);
                  }}
                  title={titleText}
                >
                  <svg
                    className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 ${
                      shouldSpin ? "rtds-animate-spin" : ""
                    }`}
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${iconName}`}
                    ></use>
                  </svg>
                  <span className="rtds-sr-only">{titleText}</span>
                </button>
              </div>
            );
          },
        },
        {
          name: "Azioni",
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => (
            <div
              className="rtds-inline-flex rtds-gap-1"
              role="group"
              aria-label="Azioni"
            >
              <button
                type="button"
                className="rtds-btn rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button"
                onClick={() => gotoVisualizzaDomanda(row.id)}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--eye`}
                  />
                </svg>
                Visualizza
              </button>{" "}
              <button
                disabled={row.isInDownload}
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button"
                onClick={() => downloadPdf(row)}
              >
                {row.isInDownload ? (
                  <>
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                      />
                    </svg>
                    <span className="rtds-sr-only">Caricamento...</span>
                  </>
                ) : (
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-down-tray`}
                    />
                  </svg>
                )}
                PDF
              </button>{" "}
            </div>
          ),
        },
      ],
      serverSide: true,
      ajax: richiestaService.getAllDt,
      ajaxParams: {
        bandoId: avviso,
        faseId: fase,
        comuneId: comune,
        statoRichiesta: statoRichiesta,
      },
      rows: [],
      sorts: [],
      hideSearch: false,
      title: "Elenco domande",
    };
    setDtOptions(dtOpt);
  };

  const onSearch = async () => {
    setCurrMapFilters(new Map(nextMapFilters));
    setAdvancedFiltersMap(new Map(nextAdvancedFiltersMap));
    setFiltriAvanzatiInStorage(nextMapFilters);
  };

  const controllaIban = async () => {
    const count = await richiestaService.countCheckIban(avviso, fase);
    setIsLoadingCheckIban(true);

    setTitle('Controllo IBAN');
    setIcona("solid--building-library");
    setIconaColor("rtds-content-02");
    setContent(`Saranno controllati ${count} IBAN, continuare?`);
    setHideActionButton(false);
    setButtonDelete(null);
    setActionLabelName("Continua");
    setActionModal(() => () => eseguiControlloIban());
    setModalOpen(true);
    setIsLoadingCheckIban(false);
  }

  const eseguiControlloIban = async () => {
    try {
      await richiestaService.startCheckIban(avviso, fase);
      setModalOpen(false);
      toastContext.success("Controllo IBAN avviato");
    } catch (error){
      setModalOpen(false);
      toastContext.warning("Controllo IBAN già in corso");
    }
  }

  const controllaDatiArs = async () => {
    const count = await richiestaService.countCheckArs(fase);
    setIsLoadingCheckArs(true);

    setTitle('Controllo ARS');
    setIcona("solid--academic-cap");
    setIconaColor("rtds-content-02");
    setContent(`Saranno controllati ${count} dati in ARS, continuare?`);
    setHideActionButton(false);
    setButtonDelete(null);
    setActionLabelName("Continua");
    setActionModal(() => () => eseguiControlloArs());
    setModalOpen(true);
    setIsLoadingCheckArs(false);
  }

  const eseguiControlloArs = async () => {
    setDisabledConfirmBtn(true);
    setDisableCloseBtn(true);
    setConfirmLoading("spinner");
    try {
      await richiestaService.startCheckArs(fase);
      setModalOpen(false);
      toastContext.success("Controllo ARS avviato");
      setDisabledConfirmBtn(false);
      setDisableCloseBtn(false);
      setConfirmLoading(null);
    } catch (error){
      setModalOpen(false);
      toastContext.warning("Controllo ARS già in corso");
      setDisabledConfirmBtn(false);
      setDisableCloseBtn(false);
      setConfirmLoading(null);
    }
  }

  const invertiEsitoPagamento = async (richiesta) => {
    try {
      const motivazioneKo = formRef.current["descrizione"].value;
      const validity = formRef.current.checkValidity();
      if (!validity) {
        setHasError(true);
        setContent(renderModalContent(richiesta, true));

        return;
      }
      await richiestaService.invertiEsitoPagamento(richiesta.id, motivazioneKo);
      dtRef.current.rerenderDatatable();
      setModalOpen(false);
      toastContext.success("L'esito del pagamento è stato aggiornato");
    } catch (error){
      setModalOpen(false);
      toastContext.warning("Errore nell'aggiornamento dell'esito del pagamento");
    }
  }

  const renderModalContent = (row, hasError) => {
    return (
      <div>
        <p>{`Per modificare l’esito del pagamento da positivo a negativo per la domanda ${row.codice} inserire la motivazione e confermare`}</p>
        <form
          ref={formRef}
          noValidate
          id="hasValidationForm"
          className="has-js-validation-form rtds-py-6 rtds-space-y-4"
        >
          <div className={'rtds-input-field rtds-gap-1' + (hasError ? ' has-error' : '')} >
            <label htmlFor={"textareahtml"} className='rtds-input-field__label'>
              Motivazione pagamento KO *
              <abbr
                hidden={true}
                className='rtds-font-bold rtds-no-underline'
                title='obbligatorio'
              >
                *
              </abbr>
            </label>
            <div className={'rtds-input' + (hasError ? ' has-error' : '')}>
              <textarea
                required={true}
                id={"textareahtml"}
                name={"descrizione"}
                className={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
                type={"text"}
                aria-describedby={"textareahtml" + 'Error'}
                aria-invalid={hasError}
                title={"descrizione"}
                maxLength={500}
              />
              {
                hasError &&
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-4 rtds-content-placeholder rtds-content-error'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
                  />
                </svg>
              }
            </div>
            <span className='rtds-input-field__hint' hidden={!hasError}>
              <span
                className='rtds-input-field__error'
                id={"textareahtml" + 'Error'}
                aria-live='assertive'
              >
                {hasError ? 'Campo obbligatorio' : ''}
              </span>
            </span>
            {
              <span className="rtds-input-field__hint">
                <span className="rtds-input-field__description" id="idselectDescription">
                  Massimo 500 caratteri
                </span>
              </span>
            }
          </div>
        </form>
      </div>
    );
  };

  const esportaDomande = () => {
    richiestaService.startEsportazioneDomande(avviso, fase).then((data) => {
      if (!data) {
        toastContext.warning("Attenzione: un'esportazione è già in corso");
      } else {
        restartPolling();
      }
    });
  };

  const restartPolling = () => {
    if (pollingInterval.current) {
      clearInterval(pollingInterval.current);
      pollingInterval.current = null;
    }
    setIsLoadingExport(true);
    startPollingDownloadExport();
  };

  const startPollingDownloadExport = () => {
    pollingInterval.current = setInterval(() => {
      richiestaService
        .downloadEsportazioneDomande()
        .then((data) => {
          switch (data.status) {
            case 'IN_CORSO':
              restartPolling();
              return;
            default:
              if (data.blobBase64?.size === 0) return;

              console.log("Esportazione completata");
              downloadFile(data.blobBase64);

              clearInterval(pollingInterval.current);
              pollingInterval.current = null;
              setIsLoadingExport(false);
              break;
          }
        })
        .catch((err) => {
          switch (err.response?.status) {
            case 404:
              console.log("File non trovato");
              break;
            default:
              console.error("Errore durante il download dell'excel: ", err);
              if (!!err.response?.status) {
                toastContext.error("Errore durante l'esportazione del csv", 5000);
              }
              clearInterval(pollingInterval.current);
              pollingInterval.current = null;
              setIsLoadingExport(false);
              break;
          }
        });
    }, 15000);
  };

  const downloadFile = (blobData) => {
    const byteCharacters = atob(blobData);
    const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "text/csv" });
    utility.downloadFile(blob, "elencoDomande.csv");
  }

  const checkEmailMassiveRettificaDomanda = () => {
    setTitle('Invio email massive rettifica domanda');
    setHideActionButton(true);
    setIcona("outline--paper-airplane");
    setIconaColor("rtds-content-02");
    setActionLabelName('Continua');
    const service = fasePresentazioneDomanda.tipologia === tipologieFase.riapertura_presentazione
      ? emailService.checkEmailMassiveRettificaIseeIbanDomanda
      : emailService.checkEmailMassiveRettificaDomanda;
    service(fasePresentazioneDomanda?.id).then(resp => {
      const contenuto = fasePresentazioneDomanda.tipologia === tipologieFase.riapertura_presentazione
        ? (resp ? 'Saranno inviate ' + resp + ' email, continuare?' : 'Non ci sono domande presentate da rettificare')
        : (resp ? 'Saranno inviate ' + resp + ' email, continuare?' : 'Non ci sono domande presentate con esito ISEE negativo')
      setContent(contenuto);
      setHideActionButton(!resp);
      setButtonDelete(null);
      setModalOpen(true);
      setActionModal(() => () => inviaEmailMassiveRettificaDomanda());
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
  }

  const inviaEmailMassiveRettificaDomanda = () => {
    const service = fasePresentazioneDomanda.tipologia === tipologieFase.riapertura_presentazione
      ? emailService.inviaEmailMassiveRettificaIseeIbanDomanda
      : emailService.inviaEmailMassiveRettificaDomanda;
    service(fasePresentazioneDomanda?.id).then(() => {
      toastContext.success("Inviata notifica per generazione email di rettifica domande");
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
    setModalOpen(false);
  }

  const checkEmailMassiveSecondoAccesso = () => {
    setTitle('Invio email massive secondo accesso');
    setHideActionButton(true);
    setIcona("outline--paper-airplane");
    setIconaColor("rtds-content-02");
    setActionLabelName('Continua');
    emailService.checkEmailMassiveSecondoAccesso(fasePresentazioneDomanda?.id).then(resp => {
      setContent(resp ? 'Saranno inviate ' + resp + ' email, continuare?' : 'Non sono presenti domande idonee');
      setHideActionButton(!resp);
      setButtonDelete(null);
      setModalOpen(true);
      setActionModal(() => () => inviaEmailMassiveSecondoAccesso());
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
  }

  const inviaEmailMassiveSecondoAccesso = () => {
    emailService.inviaEmailMassiveSecondoAccesso(fasePresentazioneDomanda?.id).then(() => {
      toastContext.success("Inviata notifica per generazione email di aggiornamento domande");
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
    setModalOpen(false);
  }

  const checkEmailMassiveIban = () => {
    setTitle('Invio email massive IBAN');
    setHideActionButton(true);
    setIcona("outline--paper-airplane");
    setIconaColor("rtds-content-02 ");
    setActionLabelName('Continua');
    emailService.checkEmailMassiveIban(fasePresentazioneDomanda?.id).then(resp => {
      setContent(resp ? 'Saranno inviate ' + resp + ' email, continuare?' : 'Non sono presenti domande idonee secondo accesso');
      setHideActionButton(!resp);
      setButtonDelete(null);
      setModalOpen(true);
      setActionModal(() => () => inviaEmailMassiveIban());
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
  }

  const inviaEmailMassiveIban = () => {
    emailService.inviaEmailMassiveIban(fasePresentazioneDomanda?.id).then(() => {
      toastContext.success("Inviata notifica per generazione email esito iban");
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
    setModalOpen(false);
  }

  const checkEmailMassiveRettificaIban = () => {
    setTitle('Invio email massive rettifica IBAN');
    setHideActionButton(true);
    setIcona("outline--paper-airplane");
    setIconaColor("rtds-content-02");
    setActionLabelName('Continua');
    emailService.checkEmailMassiveRettificaIban(fasePresentazioneDomanda?.id).then(resp => {
      setContent(resp ? 'Saranno inviate ' + resp + ' email, continuare?' : 'Non sono presenti domande idonee per rettifica IBAN');
      setHideActionButton(!resp);
      setButtonDelete(null);
      setModalOpen(true);
      setActionModal(() => () => inviaEmailMassiveRettificaIban());
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
  }

  const inviaEmailMassiveRettificaIban = () => {
    emailService.inviaEmailMassiveRettificaIban(fasePresentazioneDomanda?.id).then(() => {
      toastContext.success("Inviata notifica per generazione email di rettifica IBAN");
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
    setModalOpen(false);
  }

  const checkEmailMassiveTerzoAccesso = () => {
    setTitle('Invio email massive terzo accesso');
    setHideActionButton(true);
    setIcona("outline--paper-airplane");
    setIconaColor("rtds-content-02");
    setActionLabelName('Continua');
    emailService.checkEmailMassiveTerzoAccesso(fase?.id).then(resp => {
      setContent(resp ? 'Saranno inviate ' + resp + ' email, continuare?' : 'Non sono presenti domande idonee');
      setHideActionButton(!resp);
      setButtonDelete(null);
      setModalOpen(true);
      setActionModal(() => () => inviaEmailMassiveTerzoAccesso());
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
  }

  const inviaEmailMassiveTerzoAccesso = () => {
    emailService.inviaEmailMassiveTerzoAccesso(fase?.id).then(() => {
      toastContext.success("Inviata notifica per generazione email di aggiornamento domande terzo accesso");
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
    setModalOpen(false);
  }

  const checkEmailMassiveEsitoArs = () => {
    setTitle('Invio email massive esito ARS');
    setHideActionButton(true);
    setIcona("outline--paper-airplane");
    setIconaColor("rtds-content-02");
    setActionLabelName('Continua');
    emailService.checkEmailMassiveEsitoArs(fasePresentazioneDomanda?.id).then(resp => {
      setContent(resp ? 'Saranno inviate ' + resp + ' email, continuare?' : 'Non sono presenti domande idonee');
      setHideActionButton(!resp);
      setButtonDelete(null);
      setModalOpen(true);
      setActionModal(() => () => inviaEmailMassiveEsitoArs());
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
  }

  const inviaEmailMassiveEsitoArs = () => {
    emailService.inviaEmailMassiveEsitoArs(fasePresentazioneDomanda?.id).then(() => {
      toastContext.success("Inviata notifica per generazione email esito ARS");
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
    });
    setModalOpen(false);
  }

  return (
    <>
      <div className="rtds-container rtds-py-6">
        <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
          <div className="rtds-flex rtds-items-center rtds-justify-between">
            <h1 className="rtds-heading-2">Gestione domande</h1>
          </div>

          <Select
            classDiv={"rtds-mt-0 lg:rtds-mt-0"}
            label={"Avviso"}
            id={"avviso"}
            classSelect={""}
            onChange={(event) => {
              onChangeFilter("Avviso", event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap), true, true);
            }}
            baseOption={"Nessuna selezione"}
            bindKey={"id"}
            bindValue={"nome"}
            options={avvisi}
            value={avviso || ""}
          />
          <Select
            classDiv={"rtds-mt-0 lg:rtds-mt-0"}
            label={"Fase"}
            id={"fase"}
            classSelect={""}
            onChange={(event) => {
              onChangeFilter("Fase", event.target.value ? event.target.value : null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap), true, true);
            }}
            baseOption={"Nessuna selezione"}
            bindKey={"id"}
            bindValue={"titolo"}
            options={fasi}
            value={fase || ""}
            disabled={!avviso}
            hideSpinnerLoading={!avviso}
          />
          {avviso && fase && (
            <FiltriAvanzati
              hidden={!avviso || !fase}
              fieldsToAvoid={["Avviso", "Fase"]}
              defaultOpen={false}
              initialOpening={false}
              mapFilters={advancedFiltersMap}
              onRemoveFilter={(type) => onChangeFilter(type, null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap), true, true)}
            >
              <div className="rtds-grid rtds-gap-3">
                <div className="rtds-field-row">
                  <Select
                    classDiv={"rtds-mt-0 lg:rtds-mt-0"}
                    label={"Comune di residenza dello studente"}
                    id={"comune"}
                    classSelect={""}
                    onChange={(event) =>
                      onChangeFilter(
                        "Comune residenza",
                        event.target.value ? event.target.value : null,
                        new Map(nextMapFilters),
                        new Map(nextAdvancedFiltersMap)
                      )
                    }
                    baseOption={"Nessuna selezione"}
                    bindKey={"denominazione"}
                    bindValue={"denominazione"}
                    options={comuni}
                    value={comuni.find(c => c.id === comune)?.denominazione || ""}
                  />
                  <Select
                    classDiv={"rtds-mt-0 lg:rtds-mt-0"}
                    label={"Stato della domanda"}
                    id={"statoRichiesta"}
                    classSelect={""}
                    onChange={(event) =>
                      onChangeFilter(
                        "Stato domanda",
                        event.target.value ? event.target.value : null,
                        new Map(nextMapFilters),
                        new Map(nextAdvancedFiltersMap)
                      )
                    }
                    baseOption={"Nessuna selezione"}
                    bindKey={"key"}
                    bindValue={"value"}
                    options={statiRichiesta}
                    value={statoRichiesta || ""}
                  />
                </div>

                <div className="rtds-form-actions rtds-flex rtds-justify-start">
                  <button
                    type="button"
                    className="rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--secondary"
                    onClick={() => onSearch()}
                  >
                    Cerca
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:rtds-translate-x-1"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </FiltriAvanzati>
          )}
        </div>
      </div>

      {avviso && fase && (
        <DataTableWrapper
          ref={dtRef}
          dtOptions={dtOptions}
          reloadDatatable={true}
          headerButton={
            <div hidden={utility.checkRoles([rolesCodes.comune, rolesCodes.comuneReferente])} className="rtds-inline-flex rtds-gap-1 self-center">
              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                onClick={checkEmailMassiveRettificaDomanda}
                hidden={!showButtonMassiveRettificaEmails}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                 
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--paper-airplane`}
                  />
                </svg>
                Invia Email massive rettifica
              </button>

              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                onClick={checkEmailMassiveSecondoAccesso}
                hidden={!showButtonMassiveSecondoAccessoEmails}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                 
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--paper-airplane`}
                  />
                </svg>
                Invia Email massive secondo accesso
              </button>

              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                onClick={checkEmailMassiveIban}
                hidden={!showButtonMassiveSecondoAccessoEmails}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                 
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--paper-airplane`}
                  />
                </svg>
                Invia Email massive IBAN
              </button>

              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                onClick={checkEmailMassiveRettificaIban}
                hidden={!showButtonMassiveRettificaIbanEmails}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                 
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--paper-airplane`}
                  />
                </svg>
                Invia Email massive Rettifica IBAN
              </button>

              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                onClick={checkEmailMassiveTerzoAccesso}
                hidden={!showButtonMassiveTerzoAccessoEmails}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                 
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--paper-airplane`}
                  />
                </svg>
                Invia Email massive terzo accesso
              </button>

              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                onClick={checkEmailMassiveEsitoArs}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                 
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--paper-airplane`}
                  />
                </svg>
                Email massiva esito ARS
              </button>

              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                onClick={controllaIban}
                disabled={isLoadingCheckIban}
              >
              {isLoadingCheckIban ? (
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                  />
                </svg>
                ) : (
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--building-library`}
                    />
                  </svg>
                )}
                Controllo IBAN
              </button>

              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                onClick={controllaDatiArs}
                disabled={isLoadingCheckArs}
              >
              {isLoadingCheckArs ? (
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                  />
                </svg>
                ) : (
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--academic-cap`}
                    />
                  </svg>
                )}
                Controllo dati ARS
              </button>

              <button
                type="button"
                className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                onClick={esportaDomande}
                disabled={isLoadingExport}
                title={isLoadingExport ? 'Esportzione in corso' : 'Esporta elenco domande in CSV'}
              >
              {isLoadingExport ? (
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                  />
                </svg>
                ) : (
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-down-tray`}
                    />
                  </svg>
                )}
                Scarica CSV
              </button>
            </div>
          }
        />
      )}

      <Modal
        isOpen={isModalOpen}
        title={title}
        iconaClass={icona}
        icona={true}
        iconaColorClass={iconaColor}
        modalClassCustom='rtds-mt-20'
        content={content}
        onClose={() => closeModal()}
        onAction={actionModal ? () => actionModal() : undefined}
        actionLabel={actionLabelName}
        closeLabel="Chiudi"
        disabledConfirmBtn={disabledConfirmBtn || (domandaId && esitoDomanda != "KO")}
        disableCloseBtn={disableCloseBtn}
        hideActionButton={hideActionButton}
        confirmLoading={!!confirmLoading}
        customButton={buttonDelete}
      />
    </>
  );
}
